import { render, staticRenderFns } from "./webGL.vue?vue&type=template&id=531e598d&scoped=true&"
import script from "./webGL.vue?vue&type=script&lang=js&"
export * from "./webGL.vue?vue&type=script&lang=js&"
import style0 from "./webGL.vue?vue&type=style&index=0&id=531e598d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531e598d",
  null
  
)

export default component.exports